import {
  get,
  getOr,
  map,
  constant,
  compose,
  filter,
  identity,
} from 'lodash/fp';
import { createSelector } from 'reselect';

import {
  options as sortOptions,
  GEOLOCATION_DISTANCE_ASC,
  MONTHLY_PRICE_ASC,
  MONTHLY_PRICE_DESC,
} from 'helpers/fieldOptions/ad/sort';
import { isMonthlyPriceAvailableFeature } from 'modules/features';

const getSortOptions = createSelector(
  get(['isDistanceSortDisabled']),
  constant(isMonthlyPriceAvailableFeature),
  (isDistanceSortDisabled, isMonthlyPriceAvailable) =>
    compose(
      isMonthlyPriceAvailable
        ? identity
        : filter(
            (option) =>
              ![MONTHLY_PRICE_ASC, MONTHLY_PRICE_DESC].includes(option.value),
          ),
      map((option) => ({
        ...option,
        disabled:
          option.value === GEOLOCATION_DISTANCE_ASC && isDistanceSortDisabled,
      })),
    )(sortOptions),
);

const getVehicleMakeModel = getOr('', ['filters', 'vehicle', 0, ['value']]);

export default {
  sortOptions: getSortOptions,
  vehicleMakeModel: getVehicleMakeModel,
};
